import React, { useState } from 'react';

const defaultValue = {
  historico: [],
  periodoFechado: {},
  periodoFechadoNota: {},
  tipoSelecao: 'NENHUM',
  loading: false,
  totalElements: 0,
  modal: '',
  search: '',
  page: 0,
  size: 15,
  sort: '',
};

export const PeriodoFechadoContext = React.createContext({});

export const PeriodoFechadoProvider = (props) => {
  return (
    <PeriodoFechadoContext.Provider
      value={{
        historico: useState(defaultValue.historico),
        periodoFechado: useState(defaultValue.periodoFechado),
        periodoFechadoNota: useState(defaultValue.periodoFechadoNota),
        tipoSelecao: useState(defaultValue.tipoSelecao),
        loading: useState(defaultValue.loading),
        totalElements: useState(defaultValue.totalElements),
        modal: useState(defaultValue.modal),
        search: useState(defaultValue.search),
        page: useState(defaultValue.page),
        size: useState(defaultValue.size),
        sort: useState(defaultValue.sort),
      }}
    >
      {props.children}
    </PeriodoFechadoContext.Provider>
  );
};

export const PeriodoFechadoConsumer = PeriodoFechadoContext.Consumer;
